import { render, staticRenderFns } from "./UiTextarea.vue?vue&type=template&id=6391cb20&"
import script from "./UiTextarea.vue?vue&type=script&lang=js&"
export * from "./UiTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports